// ContainerEditorSettings — the LIVE-WIRING adapter (WL-011b).
//
// Adopts the WL-011 ContainerEditor (framework, row-39 Basic/Advanced, EW-012) into
// the real craftjs Container node: reads node props via useNode(), maps them to the
// editor's controlled `value`, and routes onChange back through setProp — keeping the
// PrevStyles reducer copy in sync exactly as the legacy Settings wrapper did.
//
// The prop<->value mapping lives in ./wiring.js (pure, unit-tested in
// harness/wiring.test.mjs) so the risky part is verified independently of the running
// builder. This adapter is wired directly as the Container block's
// craft.related.settings (Container.jsx) — the sole Container settings editor.

import React from "react";
import { useNode } from "@craftjs/core";
import { useDispatch } from "react-redux";
import { updateContainerStyles } from "../../../../redux/reducers/PrevStylesCopy/CodeblockDefaultStyles";
import { toggleSegmentSettings } from "../../../../redux/actions/segmentSettings";
import ContainerEditor from "../../BlockEditorPane/editors/ContainerEditor";
import { nodePropsToValue, applyValueToProps } from "./wiring";

const ContainerEditorSettings = ({ segmentName, onBack } = {}) => {
  const {
    actions: { setProp },
    props,
  } = useNode((node) => ({ props: node.data.props }));
  const dispatch = useDispatch();

  const value = nodePropsToValue(props);

  const handleChange = (next) => {
    dispatch(toggleSegmentSettings(false));
    setProp((draft) => {
      applyValueToProps(next, draft);
      // keep the reducer's "previous styles" copy in lock-step (legacy parity)
      dispatch(
        updateContainerStyles({
          background: draft.background,
          radius: draft.radius,
          fullWidth: draft.fullWidth,
          opacity: draft.opacity,
          spacing: { ...draft.spacing },
          margin: { ...draft.margin },
          prevMargin: draft.prevMargin,
          border: { ...draft.border },
          isApplyMarginOnAllSides: draft.isApplyMarginOnAllSides,
          isApplyPaddingOnAllSides: draft.isApplyPaddingOnAllSides,
          dropShadowColor: draft.dropShadowColor,
        })
      );
    });
  };

  return (
    <ContainerEditor
      value={value}
      onChange={handleChange}
      segmentName={segmentName}
      onBack={onBack}
    />
  );
};

export default ContainerEditorSettings;
